import Colors from '../../../../shared/assets/style/default/color';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const CardInfoText = styled.div`
  color: ${Colors['light']};
  font-family: Roboto;
  font-size: ${24 * Screen.widthRatio}px;
  overflow: hidden;
  margin-bottom: ${4 * Screen.widthRatio}px;
  position: relative;
  text-align: left;
  text-shadow: ${1 * Screen.widthRatio}px ${1 * Screen.widthRatio}px ${
  4 * Screen.widthRatio
}px black;
  width: ${295 * Screen.widthRatio}px};
  -webkit-box-orient: vertical;
`;

export default CardInfoText;
